(() => {
  const root = document.querySelector('[data-pao-stock-order]');
  if (!root || root.dataset.stockInitialized) return;
  root.dataset.stockInitialized = 'true';
  const grid = root.querySelector('.product-grid');
  const toolbar = root.querySelector('.collection-toolbar, .search-toolbar');
  if (!grid || !toolbar || !grid.querySelector('.product-card')) return;
  const initialUrl = new URL(location.href);
  const enabled = initialUrl.searchParams.get('pao_stock') !== '0';
  const pageSize = Number(root.dataset.stockPageSize) || 24;
  const label = document.createElement('label');
  label.className = 'pao-stock-priority';
  const toggle = document.createElement('input');
  toggle.type = 'checkbox';
  toggle.checked = enabled;
  label.append(toggle, document.createTextNode(' En stock d’abord'));
  toolbar.append(label);
  const status = document.createElement('p');
  status.className = 'pao-stock-note';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  toolbar.after(status);
  // Preserve the brand on Shopify's /collections/vendors?q=Nuxe endpoint.
  const facets = root.querySelector('#FacetsForm');
  if (facets && initialUrl.pathname.endsWith('/vendors') && initialUrl.searchParams.has('q')) {
    const hidden = document.createElement('input');
    hidden.type = 'hidden'; hidden.name = 'q'; hidden.value = initialUrl.searchParams.get('q');
    facets.append(hidden);
  }
  toggle.addEventListener('change', () => {
    const url = new URL(location.href);
    url.searchParams.set('pao_stock', toggle.checked ? '1' : '0');
    url.searchParams.delete('page');
    location.assign(url.href);
  });
  if (!enabled) return;
  const controller = new AbortController();
  window.addEventListener('pagehide', () => controller.abort(), {once: true});
  const timeout = setTimeout(() => controller.abort(), 45000);
  async function loadPage(page) {
    const url = new URL(initialUrl);
    url.searchParams.set('section_id', 'pao-stock-results');
    url.searchParams.delete('sections');
    url.searchParams.set('page', String(page));
    const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal});
    if (!response.ok) throw new Error('Résultats indisponibles');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-pao-stock-results]');
    if (!data) throw new Error('Classement indisponible');
    const parsed = JSON.parse(data.textContent);
    if (!Array.isArray(parsed.items) || parsed.page !== page) throw new Error('Pagination invalide');
    return parsed;
  }
  status.textContent = 'Classement des produits par stock…';
  grid.setAttribute('aria-busy', 'true');
  (async () => {
    const first = await loadPage(1);
    const batches = [first.items];
    let nextPage = 2;
    async function worker() {
      while (nextPage <= first.pages) {
        const page = nextPage++;
        const batch = await loadPage(page);
        if (batch.pages !== first.pages) throw new Error('La liste a changé');
        batches[page - 1] = batch.items;
      }
    }
    await Promise.all(Array.from({length: Math.min(3, Math.max(0, first.pages - 1))}, worker));
    const all = batches.flat();
    if (new Set(all.map(item => item.id)).size !== all.length) throw new Error('La liste a changé');
    const ordered = all.filter(item => item.inStock).concat(all.filter(item => !item.inStock));
    if (!ordered.length) throw new Error('Aucun résultat');
    clearTimeout(timeout);
    let pagination = root.querySelector('.pagination');
    if (!pagination) {
      pagination = document.createElement('nav');
      pagination.className = 'pagination';
      pagination.setAttribute('aria-label', 'Pagination');
      grid.after(pagination);
    }
    function render(page, navigate) {
      const pages = Math.ceil(ordered.length / pageSize);
      page = Math.min(Math.max(1, page), pages);
      const template = document.createElement('template');
      template.innerHTML = ordered.slice((page - 1) * pageSize, page * pageSize).map(item => item.html).join('');
      grid.replaceChildren(template.content);
      grid.removeAttribute('aria-busy');
      pagination.replaceChildren();
      pagination.hidden = pages <= 1;
      const numbers = new Set([1, pages, page - 1, page, page + 1]);
      const addLink = (number, text, aria) => {
        const url = new URL(location.href);
        url.searchParams.set('page', String(number));
        url.searchParams.set('pao_stock', '1');
        const a = document.createElement('a');
        a.href = url.href; a.textContent = text;
        if (aria) a.setAttribute('aria-label', aria);
        a.addEventListener('click', event => {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          history.pushState(null, '', a.href);
          render(number, true);
        });
        pagination.append(a);
      };
      if (page > 1) addLink(page - 1, '←', 'Page précédente');
      let last = 0;
      [...numbers].filter(n => n >= 1 && n <= pages).sort((a, b) => a - b).forEach(n => {
        if (last && n > last + 1) pagination.append(document.createTextNode(' … '));
        if (n === page) {
          const current = document.createElement('span');
          current.className = 'page current'; current.textContent = String(n);
          current.setAttribute('aria-current', 'page'); pagination.append(current);
        } else addLink(n, String(n), 'Page ' + n);
        last = n;
      });
      if (page < pages) addLink(page + 1, '→', 'Page suivante');
      status.textContent = 'Les produits en stock sont affichés en premier, les ruptures en fin de liste.';
      if (navigate) {
        toolbar.scrollIntoView({block: 'start', behavior: 'auto'});
        grid.tabIndex = -1;
        grid.focus({preventScroll: true});
      }
    }
    render(Number(initialUrl.searchParams.get('page')) || 1, false);
    window.addEventListener('popstate', () => render(Number(new URL(location.href).searchParams.get('page')) || 1, false));
  })().catch(error => {
    clearTimeout(timeout);
    grid.removeAttribute('aria-busy');
    toggle.checked = false;
    if (error.name !== 'AbortError' || !document.hidden) status.textContent = 'Le classement par stock est momentanément indisponible. Le tri habituel reste affiché.';
  });
})();
